/** Shared shell geometry (spec §2, §8 density). */
export const APP_BAR_HEIGHT = 52;
export const PHONE_FOOTER_HEIGHT = 56;
export const RAIL_WIDTH = 72;
export const SIDEBAR_WIDTH = 240;
export const SIDEBAR_COLLAPSED_WIDTH = RAIL_WIDTH;
/** Tablet and desktop content column cap (spec §2). */
export const CONTENT_MAX_WIDTH = 1040;
/** Vertical nav row height (spec §8 density). */
export const NAV_ROW_HEIGHT = 56;
/** Horizontal nav rows inset their label by 8px (spec §8 density). */
export const NAV_ROW_INLINE_PADDING = 8;
/** Horizontal nav row labels match body1 (spec §8). */
export const NAV_LABEL_FONT_SIZE = "0.9375rem";
/** Phone footer labels (spec §8 density). */
export const FOOTER_LABEL_FONT_SIZE = "0.68rem";
